export default "__VITE_ASSET__6Be471JX__"